/**
 * GARGALO PRINCIPAL — resposta principal da aba Gargalo.
 */
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { EXEC_HERO_CLASS } from './opsExecutiveShared';

export interface PrimaryBottleneck {
  stageName: string;
  wip: number;
  leadTimeHours: number;
  slaImpactPct: number;
  slaSampled?: boolean;
  affectedActions: number;
  responsibleName?: string | null;
}

interface OpsPrimaryBottleneckCardProps {
  bottleneck: PrimaryBottleneck | null;
}

export const OpsPrimaryBottleneckCard: React.FC<OpsPrimaryBottleneckCardProps> = ({ bottleneck }) => {
  if (!bottleneck) {
    return (
      <div className={`${EXEC_HERO_CLASS} border-l-2 border-l-emerald-500/70 px-4 py-3`}>
        <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-emerald-600">Gargalo Principal</p>
        <p className="mt-1 text-[13px] font-medium text-[var(--text-primary)]">Nenhum gargalo crítico identificado no período.</p>
      </div>
    );
  }

  return (
    <div className={`${EXEC_HERO_CLASS} shrink-0 border-l-[3px] border-l-red-500/80`}>
      <div className="flex flex-wrap items-start justify-between gap-3 px-4 py-3">
        <div className="flex items-start gap-2.5">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-sm bg-red-500/10">
            <AlertTriangle size={20} className="text-red-500" />
          </div>
          <div>
            <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-red-600">Gargalo Principal</p>
            <p className="mt-0.5 text-[16px] font-bold text-[var(--text-primary)]">{bottleneck.stageName}</p>
            <span className="mt-1 inline-flex rounded-sm bg-red-500/10 px-1.5 py-0.5 text-[9px] font-bold uppercase text-red-600">
              GARGALO
            </span>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-x-6 gap-y-1 sm:grid-cols-4">
          <div>
            <p className="text-[9px] font-bold uppercase text-[var(--text-muted)]">WIP</p>
            <p className="text-[18px] font-bold tabular-nums text-[var(--text-primary)]">{bottleneck.wip}</p>
          </div>
          <div>
            <p className="text-[9px] font-bold uppercase text-[var(--text-muted)]">Lead Time</p>
            <p className="text-[18px] font-bold tabular-nums text-[var(--text-primary)]">{bottleneck.leadTimeHours > 0 ? `${bottleneck.leadTimeHours.toFixed(1)}h` : '—'}</p>
          </div>
          <div>
            <p className="text-[9px] font-bold uppercase text-[var(--text-muted)]">Impacto SLA</p>
            <p className={`text-[18px] font-bold tabular-nums ${bottleneck.slaSampled === false ? 'text-[var(--text-muted)]' : 'text-red-500'}`}>
              {bottleneck.slaSampled === false ? '—' : `${bottleneck.slaImpactPct.toFixed(0)}%`}
            </p>
          </div>
          <div>
            <p className="text-[9px] font-bold uppercase text-[var(--text-muted)]">Ações afetadas</p>
            <p className="text-[18px] font-bold tabular-nums text-[var(--text-primary)]">{bottleneck.affectedActions}</p>
          </div>
          {bottleneck.responsibleName && (
            <div>
              <p className="text-[9px] font-bold uppercase text-[var(--text-muted)]">Responsável</p>
              <p className="truncate text-[14px] font-bold text-[var(--text-primary)]">{bottleneck.responsibleName}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OpsPrimaryBottleneckCard;
